import { Component, OnInit, ViewEncapsulation, Renderer2, ElementRef } from '@angular/core';
import { AuthenticationService } from '@shared/services/authentication.service';
import { IntercomTags, InternalAnalyticsService } from '@shared/services/internalAnalytics.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Observable } from 'rxjs';
import { Hub } from '@shared/models/hub.model';
import { OverlayContainer } from '@angular/cdk/overlay';
import { HubEditComponent } from '@app/main/hub/hub-edit/hub-edit.component';
import { filter } from 'rxjs/operators';
import { HubMode, PlanType } from '@shared/models';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { environment } from '@env/environment';

@Component({
  selector: 'user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent implements OnInit {
  hubObs: Observable<Hub>;
  user: any | null;
  undefined_url = 'assets/wonda/portrait.png';
  constructor(
    private _authService: AuthenticationService,
    private _internalAnalyticsService: InternalAnalyticsService,
    private _router: Router,
    private _hubService: CurrentHubService,
    private _overlayContainer: OverlayContainer,
    private _renderer: Renderer2,
    private _elementref: ElementRef,
    private route: ActivatedRoute,
    private _dialog: MatDialog
  ) {
    this.hubObs = this._hubService.hubObservable;
    this._overlayContainer.getContainerElement().classList.add('learnspace-theme');
  }

  ngOnInit(): void {
    this._authService.userState.subscribe((user) => {
      if (user) {
        this.user = user;
        this.user.name = user.first_name;

        const firebaseUser = this._authService.getCurrentUser();
        // Get photo from providerData
        if (firebaseUser.providerData && firebaseUser.providerData[0] && firebaseUser.providerData[0].photoURL) {
          this.user.photo = firebaseUser.providerData[0].photoURL;
        }
        // Get photo from Firebase Data
        else if (firebaseUser.photoURL !== null) {
          this.user.photo = firebaseUser.photoURL;
        } else {
          this.user.photo = this.undefined_url;
        }
        this.user.Hubs = user.Hubs;
        this._internalAnalyticsService.initIntercomWithUser(user);
        this._internalAnalyticsService.identifyHeapUser(user);
      } else {
        this.user = null;
      }
    });
  }

  signOut(): void {
    this._authService.logout();
  }
  async switchHub(hub: Hub): Promise<void> {
    await this._hubService.setCurrentHub(hub);
    this._router.navigate([hub.urlTitle]);
  }
  isAdmin(): boolean {
    return this._authService.isAdmin();
  }
  isAdminOfHub(): boolean {
    return this._hubService.canAdminCurrentHub();
  }
  openHubSettings(toTabIndex: number = 0): void {
    if (!this.isAdminOfHub()) {
      return;
    }

    this._dialog
      .open(HubEditComponent, {
        width: 'min(90vw, 900px)',
        height: 'min(90vh, 800px)',
        panelClass: 'learnspace-theme',
        autoFocus: false,
        data: { toTabIndex: toTabIndex }
      })
      .afterClosed()
      .pipe(filter((val) => val))
      .subscribe(async () => {
        await this._hubService.reloadCurrentHub();
      });
  }
  openAnalytics(): void {
    const urlTitle = this._hubService.getHubURLTitle();
    this._router.navigate(['analytics/' + urlTitle]);
  }

  openBackoffice(): void {
    window.open(`${environment.coursesApiUrl}/admin/hubs/${this._hubService.hub.id}/view`, '_blank');
  }

  getDaysLeft(): number {
    return this._hubService.planTimeLeft();
  }
  getPlan(): PlanType {
    return this._hubService.getHubPlan();
  }
  isFreePlan(): boolean {
    return this._hubService.isFree();
  }
  isProgramMode(): boolean {
    return this._hubService.getHubMode() == HubMode.program;
  }
  goToRoot(): void {
    let newhub;
    if (this._hubService.hub && this._hubService.hub !== null) {
      newhub = this._hubService.hub;
    }
    this._router.navigate([newhub ? newhub.urlTitle : '/']);
  }
  openInfoPage(): void {
    window.open('https://www.wonda.pro/contact-us');
  }
  goToBilling(): void {
    if (!this.isFreePlan()) {
      this.openHubSettings(3);
    } else {
      const urlTitle = this._hubService.getHubURLTitle();
      this._router.navigate(['plans', urlTitle]);
    }
  }
  contactSales(): void {
    this._internalAnalyticsService.showNewMessage();
  }
  openPlanDoc(): void {
    window.open('https://help.spaces.wondavr.com/en/articles/6212470-which-plan-is-the-right-one-for-you');
  }
  openHelp(): void {
    if (this._hubService.hub && this._hubService.hub.mode === HubMode.program) {
      window.open('https://intercom.help/wonda-pro/');
      this._internalAnalyticsService.addIntercomUserTag(IntercomTags.WONDA_PRO_HAS_CONSULTED_HELP);
    } else {
      window.open('http://help.spaces.wondavr.com');
    }
  }
}
